import React, { useState } from 'react';
import { LogOut, ChevronDown } from 'lucide-react';

const UserMenu = ({ user, logout }) => {
  const [open, setOpen] = useState(false);

  if (!user) return null;

  return (
    <div className="relative ml-2">
      <button
        onClick={() => setOpen(!open)}
        className="flex items-center gap-2 px-3 py-2 rounded-xl hover:bg-slate-100 transition-colors"
        data-testid="user-menu-btn"
      >
        <div className="w-8 h-8 bg-gradient-to-br from-teal-500 to-emerald-600 rounded-full flex items-center justify-center text-white text-xs font-bold">
          {(user.name || user.email || '?')[0].toUpperCase()}
        </div>
        <ChevronDown className="h-3 w-3 text-slate-400" />
      </button>
      {open && (
        <>
          <div className="fixed inset-0 z-40" onClick={() => setOpen(false)}></div>
          <div className="absolute right-0 mt-2 w-56 bg-white rounded-xl shadow-2xl border border-slate-100 z-50 overflow-hidden" data-testid="user-menu-dropdown">
            <div className="px-4 py-3 border-b border-slate-100">
              <p className="font-semibold text-sm text-slate-900 truncate">{user.name}</p>
              <p className="text-xs text-slate-500 truncate">{user.email}</p>
              <span className="inline-block mt-1 px-2 py-0.5 bg-teal-50 text-teal-700 text-[10px] font-semibold uppercase rounded-full">{user.role}</span>
            </div>
            <button
              onClick={() => { setOpen(false); logout(); }}
              className="w-full text-left px-4 py-3 text-sm text-red-600 hover:bg-red-50 flex items-center gap-2 transition-colors"
              data-testid="logout-btn"
            >
              <LogOut className="h-4 w-4" />
              Sign Out
            </button>
          </div>
        </>
      )}
    </div>
  );
};

export default UserMenu;
